import React from 'react'

const STRATEGY_GUIDE = [
  ['CSP', 'Cash Secured Put', 'Selling the right for someone to sell you 100 shares at the strike price. You collect premium upfront.'],
  ['CC', 'Covered Call', 'Selling the right for someone to buy your 100 shares at the strike price. You collect premium upfront.'],
  ['Wheel', 'The Wheel Strategy', 'Combining CSPs and Covered Calls on the same stock to generate recurring income repeatedly.'],
  ['0DTE Spread', 'Zero Days to Expiration', 'A same-day bull put spread on SPX. Expires at market close today.'],
  ['Bull Put Spread', '', 'Selling a put at a higher strike and buying a put at a lower strike for defined risk.'],
  ['Bear Call Spread', '', 'Selling a call at a lower strike and buying a call at a higher strike for defined risk.'],
  ['Swing', 'Swing Trade', 'A multi-day directional trade held for days to weeks.'],
];

const StrategyInfoTooltip = () => {
  const [show, setShow] = React.useState(false);
  const [above, setAbove] = React.useState(true);
  const ref = React.useRef(null);

  const handleMouseEnter = () => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      setAbove(rect.top > 300);
    }
    setShow(true);
  };

  React.useEffect(() => {
    if (!show) return;
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setShow(false); };
    document.addEventListener('click', handler, true);
    return () => document.removeEventListener('click', handler, true);
  }, [show]);

  return (
    <span ref={ref} style={{ position: 'relative', display: 'inline' }}>
      <span
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => setShow(false)}
        onClick={(e) => { e.stopPropagation(); setShow(s => !s); }}
        style={{ fontSize: '12px', color: 'rgba(201,168,76,0.6)', cursor: 'help', marginLeft: '6px', verticalAlign: 'middle', textTransform: 'none', display: 'inline', fontStyle: 'normal', fontWeight: 'normal', letterSpacing: 'normal' }}
      >ⓘ</span>
      {show && (
        <span style={{ position: 'absolute', ...(above ? { bottom: 'calc(100% + 8px)' } : { top: 'calc(100% + 8px)' }), left: 0, background: '#18181c', border: '1px solid rgba(201,168,76,0.4)', borderRadius: '8px', padding: '14px 16px', width: '300px', maxWidth: 'min(300px, calc(100vw - 32px))', zIndex: 9999, boxShadow: '0 4px 20px rgba(0,0,0,0.6)', pointerEvents: 'none', textTransform: 'none', letterSpacing: 'normal', fontStyle: 'normal', fontWeight: 'normal', display: 'block' }}>
          {STRATEGY_GUIDE.map(([abbr, full, desc]) => (
            <span key={abbr} style={{ display: 'block', marginBottom: '10px' }}>
              <span style={{ display: 'block', fontFamily: "'Jost',sans-serif", fontSize: '11px', fontWeight: 600, color: '#c9a84c' }}>{abbr}{full ? ` — ${full}` : ''}</span>
              <span style={{ display: 'block', fontFamily: "'Jost',sans-serif", fontSize: '11px', color: 'rgba(240,237,230,0.75)', lineHeight: 1.55, marginTop: '2px' }}>{desc}</span>
            </span>
          ))}
        </span>
      )}
    </span>
  );
};

export default StrategyInfoTooltip
